export default {
  wxShareFun (shareDate) {
    wx.ready(function () {
      wx.onMenuShareAppMessage(shareDate)
      wx.onMenuShareTimeline(shareDate)
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/js/util.js